import { render, staticRenderFns } from "./corneaNPJ.vue?vue&type=template&id=6c3bb268&scoped=true&"
import script from "./corneaNPJ.vue?vue&type=script&lang=js&"
export * from "./corneaNPJ.vue?vue&type=script&lang=js&"
import style0 from "./corneaNPJ.vue?vue&type=style&index=0&id=6c3bb268&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3bb268",
  null
  
)

export default component.exports